import { getDataLayer } from './dataLayer.js';
export const trackEventWithGtm = (event) => {
    const dataLayer = getDataLayer();
    dataLayer.push({
        event: event.name,
        params: event.params,
    });
};
//# sourceMappingURL=gtm.js.map